import { useMutation } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { PROPERTY_CHANNEL_MANAGERS } from '~/consts/reservation';

import { detectMissingProducts } from '~/services/ConnectionDerbysoftService';
import { detectMissingRates } from '~/services/ConnectionSynxisService';

const SUPPORTED_CHANNEL_MANAGERS = [PROPERTY_CHANNEL_MANAGERS.derbysoft, PROPERTY_CHANNEL_MANAGERS.synxis] as const;
export type SupportedChannelManager = (typeof SUPPORTED_CHANNEL_MANAGERS)[number];

export function isSupportedChannelManager(channelManager: string): channelManager is SupportedChannelManager {
  return SUPPORTED_CHANNEL_MANAGERS.includes(channelManager as SupportedChannelManager);
}

export function useDetectMissingRates() {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: async ({
      propertyId,
      channelManager,
    }: {
      propertyId: string;
      channelManager: SupportedChannelManager;
    }) => {
      if (channelManager === PROPERTY_CHANNEL_MANAGERS.derbysoft) {
        return detectMissingProducts(propertyId);
      }
      return detectMissingRates(propertyId);
    },
    onSuccess: (_data, variables) => {
      enqueueSnackbar(`Job enqueued for property ${variables.propertyId}`, { variant: 'success' });
    },
    onError: (error: Error) => {
      enqueueSnackbar(`Failed to enqueue job: ${error.message}`, { variant: 'error' });
    },
  });
}
